{
  "version": 1,
  "asset_id": "f25ec767-f625-41f1-bceb-07c59100d0c0",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/f25ec767-f625-41f1-bceb-07c59100d0c0/ss01-slide.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/f25ec767-f625-41f1-bceb-07c59100d0c0/ss01-slide.webp",
  "original_filename": "ss01-slide.webp",
  "size": 107766,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:23:01Z"
}
